<template>
  <div class="users-layout">
    <default-box
        :loader="loading">
      <div class="d-flex justify-content-between align-items-center mb-10">
        <div class="row col-md-8 align-items-center justify-content-start row-column">
          <div class="col-md-4">
            <search-input
                class="search-input"
                :value="search"
                :placeholder="$t('inputs.search')"
                @change="searchFetchList"
            />
          </div>
        </div>
        <router-link-to
            default_button
            :route_name="route_names.editDocument"
            :route_params="{id: 0}">
          {{ $t('documents.new') }}
        </router-link-to>
      </div>
      <tables-slot
          :empty_spacer="loading"
          @paginationFetch="fillData"
          @popstateEvent="fetchList"
          :pagination="pagination">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">#</td>
          <td class="w-0 text-nowrap">{{ $t('documents.title') }}</td>
          <td class="w-0 text-nowrap">{{ $t('tables.edit') }}</td>
        </template>
        <template v-slot:table_body>
          <tr v-for="item in list">
            <td class="w-0 text-nowrap">
              {{ item.id }}
            </td>
            <td class="w-0 text-nowrap">
              {{ item.title }}
            </td>
            <td class="w-0 text-nowrap">
              <span
                  @click="deleteDocument(item.id)"
                  class="d-inline-block px-10 py-10 cursor_pointer">
                <trash-icon/>
              </span>
              <router-link-to
                  class="d-inline-block px-10 py-10"
                  :route_params="{id: item.id}"
                  :route_name="route_names.editDocument">
                <edit-icon/>
              </router-link-to>
            </td>
          </tr>
        </template>
      </tables-slot>
    </default-box>
  </div>
</template>

<script>

import {axiosArticles, axiosDocuments} from "../../../helpers/axios_requests";
import {REPLACE_IN_QUERY, REPLACE_STATE} from "../../../helpers/url_helper";
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import Switcher from "../../small_components/Switcher.vue";
import EditIcon from "../../icons/EditIcon.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import CloseIcon from "../../icons/CloseIcon.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import LogoutIcon from "../../icons/LogoutIcon.vue";
import TrashIcon from "../../icons/TrashIcon.vue";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import DefaultSelect from "../../small_components/DefaultSelect.vue";

export default {
  name: 'DocumentsLayout',
  mixins: [routes_mixin],
  components: {
    DefaultSelect,
    TrashIcon,
    LogoutIcon,
    DefaultButton,
    CloseIcon,
    DefaultInput,
    SearchInput,
    DefaultBox,
    EditIcon,
    Switcher,
    TablesSlot,
    RouterLinkTo,
  },
  computed: {

  },
  beforeMount() {
    this.fetchList()
  },
  data() {
    return {
      list: [],
      pagination: [],
      loading: false,
      search: '',
    }
  },
  methods: {
    searchFetchList(e) {
      this.search = e.target.value
      REPLACE_STATE(
          REPLACE_IN_QUERY(location.search, 'search', this.search)
      )
      this.fetchList()
    },
    fetchList() {
      this.loading = true

      axiosDocuments.list({
        search: this.search
      })
          .then(r => this.fillData(r.data))
          .finally(() => {
            this.loading = false
          })
    },
    fillData({collection, pagination}) {
      this.list = collection || []
      this.pagination = pagination || []
    },
    deleteDocument(id) {
      this.loading = true
      axiosDocuments.delete(id)
          .then(r => this.fetchList())
          .finally(() => {
            this.loading = false
          })
    },
    changePublished(id) {
      this.loading = true
      axiosDocuments.setPublished({id: id})
          .then((r) => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            let message = this.$i18n.t('articles.published');
            if (r.data.published === 1) {
              message = this.$i18n.t('articles.unpublished');
            }

            this.actionPushNotification({message: message, status: STATUS_SUCCESS})
          }).catch((r) => {
        console.log(r)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
